var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadStatementsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1059_69331)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 16.0706L14.5834 21.904M20.0001 16.0706L25.4167 21.904M20.0001 16.0706V21.0274V25.9842V35.8977M24.6563 25.9123C24.6563 25.9123 29.3313 26.0915 31.1542 25.2873C32.4259 24.7118 33.524 23.8123 34.3386 22.6788C35.1533 21.5453 35.6558 20.2178 35.7959 18.829C36.0688 16.1019 34.8251 13.1061 32.4751 11.6561C31.3063 10.9373 29.9417 10.6456 28.5771 10.5269C27.8001 10.5045 27.0225 10.5372 26.2501 10.6248C25.7098 8.90297 24.67 7.38058 23.2626 6.25104C21.8552 5.1215 20.1438 4.4358 18.3459 4.28106C16.9451 4.1795 15.5402 4.41168 14.2465 4.95855C12.9529 5.50541 11.8074 6.35135 10.9042 7.42689C10.0198 8.48439 9.38533 9.72774 9.04797 11.0644C8.95839 11.4186 8.78131 12.4061 8.78131 12.4061C7.86973 12.6993 7.02805 13.1765 6.30839 13.8081C4.11881 15.7665 3.58547 19.1123 4.81047 21.7456C5.92297 24.1373 8.31256 25.9123 10.9709 25.9123H15.3459",
    stroke: "#E60000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1059_69331"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadStatementsIcon);
export default __webpack_public_path__ + "static/media/upload-statements-icon.4b7a65477b54a141e3021449e4ca9c5d.svg";
export { ForwardRef as ReactComponent };